import {getOutlet, hasOutlet} from 'reconnect.js';

const outletName = 'ApiUtil';
const HANDLED_ERROR = Symbol('handled-api-error');

function handledError(value) {
  return {[HANDLED_ERROR]: true, value};
}

function redirect(url) {
  const {modifyRedirectUrl} =
    (hasOutlet(outletName) && getOutlet(outletName).getValue()) || {};

  if (modifyRedirectUrl) {
    url = modifyRedirectUrl(url);
  }

  window.location.href = url;
}

async function req(
  url_,
  {method = 'GET', headers = {}, data, ...restOptions} = {},
  options = {},
) {
  const {onJson, onError, modifyFetchArgs} =
    (hasOutlet(outletName) && getOutlet(outletName).getValue()) || {};
  const {ignoreOnErrorHook, ignoreStatusCheck} = options;

  let fetchArgs = [
    url_,
    {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      ...(method !== 'GET' && data ? {body: JSON.stringify(data)} : {}),
      ...restOptions,
    },
  ];

  if (modifyFetchArgs) {
    fetchArgs = modifyFetchArgs(...fetchArgs);
  }

  const resp = await fetch(...fetchArgs);
  const url = fetchArgs[0];
  const fetchPayload = fetchArgs[1];

  if (ignoreStatusCheck || (200 <= resp.status && resp.status < 400)) {
    try {
      const jsonResp = await resp.json();
      return typeof onJson === 'function'
        ? onJson(url, fetchPayload, jsonResp)
        : jsonResp;
    } catch (ex) {
      return null;
    }
  }

  if (!ignoreOnErrorHook && typeof onError === 'function') {
    const hookResult = await onError(url, fetchPayload, resp);
    if (hookResult?.[HANDLED_ERROR]) {
      return hookResult.value;
    }
  }

  const err = {status: resp.status, response: undefined};
  try {
    err.response = await resp.json();
  } catch (ex) {
    // The response has no JSON error body.
  }
  throw err;
}

export {handledError, req, redirect};
